/**
 * Set as `REACT_APP_ENABLE_NATIVE_TOUR_MODEL`; the server strips the prefix.
 * Off where unset, so only staging gets the tours build screens.
 */
export function isNativeTourModelEnabled(): boolean {
  return window.configs?.ENABLE_NATIVE_TOUR_MODEL === 'true';
}

export const SUPPLIERS_PATH = '/tours/lists/suppliers';

export function supplierPath(supplierId: string): string {
  return `${SUPPLIERS_PATH}/${supplierId}`;
}
